
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from './partner-entity';
import { Ticket } from 'src/app/assabil-services/models/entities/ticket';
import { AssetProduct } from '../control-tables/asset-product-entity';
import { Branch } from '../control-tables/branch-entity';
import { PartnerSite } from '../control-tables/partner-site-entity';
import { Contract } from '../control-tables/contract-entity';


export class Asset extends BaseEntity {
  assetCode      : string;
  serialNumber   : string;
  barCode        : string;
  assetProduct   : AssetProduct = new AssetProduct();
  assetOrderCode : string;
  branch         : Branch = new Branch();
  partner        : Partner = new Partner();
  partnerSite    : PartnerSite = new PartnerSite();
  mntPartner     : Partner = new Partner();
  contract       : Contract = new Contract();
  name           : string;
  assetStatusCode: string;

  tickets        : Ticket[];

  receptionDate	  : Date;
  exitDate	      : Date;
  

  inventoried    : boolean
  rejected        : boolean;
  rejectionReason : string;
}
